export const TYPING_RULE_TEXT =
  '1. **Clarify** — If any requirement is fuzzy, ambiguous, or underspecified, use the `AskUserQuestion` tool to resolve it before writing code. Do not guess.';

export const ROLE_LIST = [
  { key: 'engineering', label: 'Engineering', meta: '12 members', selected: true },
  { key: 'product', label: 'Product', meta: '4 members', selected: false },
  { key: 'design', label: 'Design', meta: '3 members', selected: false },
  { key: 'qa', label: 'QA', meta: '2 members', selected: false }
] as const;

export type DemoTab = 'edit' | 'preview' | 'history';

export type DemoPhase =
  | 'idle'
  | 'typing'
  | 'typedHold'
  | 'saving'
  | 'fly'
  | 'propagate'
  | 'hold';

export const TIMING_MS = {
  holdStart: 900,
  charInterval: 28,
  typedHold: 400,
  saving: 650,
  flyDrop: 820,
  flyHoldOnSave: 320,
  flyToHistory: 1400,
  propagate: 1400,
  holdEnd: 1200,
  layoutSettle: 80
} as const;
